import React from 'react'
import classNames from "classnames";
import withStyles, { ClassNameMap } from "@material-ui/core/styles/withStyles";
import { PhaseTag } from "../../models/PhaseTag";
import { ContextMenuTrigger } from "react-contextmenu";
import { Draggable, DraggableProvided, DraggableStateSnapshot } from '../react-beautiful-dnd';
import { ColumnType } from "./Column";
import { Tag } from "../../models/Tag";
import { LookaheadTag, LookaheadTagStatus } from "../../models/LookaheadTag";
import { connect } from 'react-redux';
import { compose } from 'redux';
import { tagCardStyle, WhiteTextTypography } from '../../containers/dockPadStyle'
import { ThunkDispatch } from 'redux-thunk';
import { phasePlanActions } from '../../actions/phaseplan.actions';
import { lookaheadActions } from '../../actions/lookahead.actions';
import { makeIsTagSelected, isTagCommitted, isLockedDown, makeGetTagData } from '../../selectors/lookahead.selector';
import { createSelectable } from '../react-selectable-fast'
import fontColorContrast from 'font-color-contrast';
import { isConstraintTag, TagType, SelectedTag } from '../../models/ TagType';
import Badge from '../materialUI/Badge'
import Avatar from '@material-ui/core/Avatar';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import { createPortal } from 'react-dom';

import '../../containers/App.css'
import { alertActions } from '../../actions/alert.actions';
import { getSize, getZoomAmount } from './Zoom.util';
import { Typography } from '@material-ui/core';
import chroma from 'chroma-js'
import NotInterestedIcon from '@material-ui/icons/NotInterested';
import { getZoom } from '../../selectors/util.selector';

require('../../assets/react-contextmenu.css');

export interface CardProps {
    uid: string,
	name?: string | null,
	tagCardType: string,
	tradeId?: string | null,
	isMilestone?: boolean | null,
	tagDate: string,
	status: string,
	description?: string | null,
	crewSize: number,
    locationId: string,
    
    type: ColumnType;
    zoomStep?: number | null;
    classes: ClassNameMap;
    index: number
    column: number,
    isDisabled: boolean,
    tradeName: string
    tradeColor: string,
    onLookaheadTagClicked: (event:any, tagId:string, selectedTag: SelectedTag) => void,
    onLookaheadTagDoubleClicked: (event:any, tagId:string, isMilestone?:boolean, selectedTag: SelectedTag) => void,
    onPhasePlanTagClicked: (event:any, tagId:string, selectedTag: SelectedTag) => void,
    onPhasePlanTagDoubleClicked: (event:any, tagId:string, selectedTag: SelectedTag) => void,
    errorAlert: (message: string) => void
    isTagSelected: boolean,
    selectableRef: any,
    isSelected: boolean,
    isSelecting: boolean,
    isTagCommitted: boolean,
    isLockedDown: boolean,
    isAdmin: boolean,
    userTrades: Set<string>,
    zoom: number
}

const SmallAvatar = withStyles(() => ({
  root: {
    width: 18,
    height: 18
  },
}))(Avatar)



let _dragEL = document.getElementById('draggable');

class _TagCard extends React.Component<CardProps> {

    
        
    onTagDoubleClick = (event: any) => {
        event.stopPropagation()
        event.preventDefault()
        const { 
            type, 
            onPhasePlanTagDoubleClicked, 
            onLookaheadTagDoubleClicked,  
            column, 
            index, 
            tagCardType,
            isDisabled,
            isLockedDown 
        } = this.props

        const canAccessTag =  this.canAccessTag()
        if(!canAccessTag) {
            return
        }

        const tagId = this.props.uid
        if(!tagId || isDisabled || isLockedDown) {
            return
        }

        const isMilestone = this.props.isMilestone;


        if(type === ColumnType.PhasePlan) {
            onPhasePlanTagDoubleClicked(event, tagId, {
                tagType: tagCardType,
                tagCardType: tagCardType,
                position: {
                    column,
                    row: index
                }
            })
        }

        if(type === ColumnType.Lookahead) {
            onLookaheadTagDoubleClicked(event, tagId, isMilestone, {
                tagType: tagCardType,
                tagCardType: tagCardType,
                position: {
                    column,
                    row: index
                }
            })
        }
    }

    onTagClick = (event: any) => {
        event.stopPropagation()
        event.preventDefault()

        const { 
            type,  
            onPhasePlanTagClicked,
            onLookaheadTagClicked, 
            column, 
            index, 
            uid,
            tagCardType,
            isDisabled,
            errorAlert,
            isLockedDown 
        } = this.props

        const tagId = uid

        if(isDisabled && type === ColumnType.PhasePlan) {
            console.log('PhasePlan disabled and clicked', isDisabled, type)
            errorAlert("Phase Plan is in Progress and Locked")
            return
        }

        const canAccessTag =  this.canAccessTag()
        if(!canAccessTag) {
            return
        }

        if(!tagId || isDisabled || isLockedDown) {
            return
        }
        if(type === ColumnType.PhasePlan) {
            onPhasePlanTagClicked(event, tagId,{
                tagType: tagCardType,
                tagCardType: tagCardType,
                position: {
                    column,
                    row: index
                }
            })
        }

        if(type === ColumnType.Lookahead) {
            onLookaheadTagClicked(event, tagId, {
                tagType: tagCardType,
                tagCardType: tagCardType,
                position: {
                    column,
                    row: index
                }
            })
        }

    }

    getStatus = (lookaheadTag: LookaheadTag) => {
        const status = (!lookaheadTag.status || !LookaheadTagStatus[lookaheadTag.status]) ? LookaheadTagStatus[LookaheadTagStatus.Todo] : LookaheadTagStatus[lookaheadTag.status]

        return status
    }

    renderLocation = () => {
        const {tradeColor, type, locationId, tradeName, classes, zoomStep} = this.props
        
        const zoomAmount = getZoomAmount(zoomStep)

        const { fontSize, paddingLeft, averagePadding, iconSize } = getSize(zoomAmount)
        if(!!zoomStep && zoomStep > 11) {
            return
        }

        return (
            <div className={classes.TagLocationContentContainer} style={{ marginTop: averagePadding, marginBottom: averagePadding, }}>
                <div className={classes.TagLocationContent} >
                    <WhiteTextTypography color='textPrimary' style={{
                        fontSize: fontSize, 
                    }}  variant="body2" >{locationId}</WhiteTextTypography>
                </div>
            </div>
        )
    }

    getStatusColor = (status:LookaheadTagStatus) => {
        if(status == LookaheadTagStatus.Todo) {
            return '#03a9f4'
        }

        if(status == LookaheadTagStatus.WorkingOn) {
            return '#ff9800'
        }

        if(status == LookaheadTagStatus.Done) {
            return '#cddc39'
        }
        if(status == 'DoneDone') {
            return '#4caf50'
        }

        return '#000'
    }

    renderCantAccessIcon = () => {
        const canAccess = this.canAccessTag()
        const { isLockedDown } = this.props

        const {tradeColor, zoomStep} = this.props

        const zoomAmount = getZoomAmount(zoomStep)

        const { iconSize } = getSize(zoomAmount)


        if(!canAccess || isLockedDown) {
            return (
                <NotInterestedIcon style={{height: iconSize, width: iconSize, color: tradeColor }} />
            )
        }
    }


    renderContent = () => {
        const { name, crewSize, description, tagCardType, isMilestone } = this.props
        
        const {tradeColor, type, tradeName, classes, zoomStep} = this.props

        const zoomAmount = getZoomAmount(this.props.zoomStep)

        const { fontSize, paddingLeft, averagePadding, iconSize } = getSize(zoomAmount)

        const fontColor = fontColorContrast(tradeColor)

  

        if(tagCardType === TagType.Constraint) {
            return(
                <p style={{
                    zIndex: 1,
                    color: fontColor,
                    fontSize: fontSize,
                    '-webkit-font-smoothing': 'antialiased',

                    textAlign: 'center',
                    marginTop: '10px',
                    wordWrap: 'break-all',
                    }} 
                className='Constraint-Text'>
                    {description}
                </p>
            )
        }

        if(type === ColumnType.PhasePlan) {
            //const phaseTag = tag as PhaseTag
            return (
                <div style={{ paddingLeft: averagePadding }} className={classes.TagCardContent}>
                        {this.renderLocation()}
                        <div className={classes.TagNameContainer}>
                            <Typography className={classes.TagNameText} style={{'-webkit-font-smoothing': 'antialiased',fontSize: fontSize, fontWeight: 'bold'}}  variant="body2">{name}</Typography>
                        </div>
                        <div className={classes.TagCrewContent}>
                            <AccountCircleIcon style={{height: iconSize, width: iconSize, color: tradeColor }} /><Typography style={{fontSize: fontSize}}  variant="body2">{crewSize}</Typography>
                        </div>
                    </div>
            )
        }

        if(type === ColumnType.Lookahead && !isMilestone) {
            //const lookaheadTag = tag as LookaheadTag

            const statusColor = this.getStatusColor(this.props.status)
            return (
                <div style={{ paddingLeft: averagePadding }} className={classes.TagCardContent}>
                    {this.renderLocation()}
                    <div className={classes.TagNameContainer}>
                        <Typography className={classes.TagNameText} style={{fontSize: fontSize}}  variant="body2">{name}</Typography>
                    </div>
                    <div className={classes.TagStatusBottomContent}>
                        <div className={classes.TagCrewContent}>
                            <AccountCircleIcon style={{height: iconSize, width: iconSize, color: tradeColor }} /><Typography style={{fontSize: fontSize}}  variant="body2">{crewSize}</Typography>
                        </div>
                        {this.renderCantAccessIcon()}
                    </div>
                </div>
            )
        }

        if(type === ColumnType.Lookahead && !!isMilestone) {
            return (
                <Typography 
                    className={classes.MilestoneTitle} 
                    style={{
                        fontSize: fontSize,
                        color: fontColor,
                    }}>
                        {name}
                </Typography >
            )
        }
    }
    renderTradeColor = () => {
        const { classes, tradeColor} = this.props

        const zoomAount = getZoomAmount(this.props.zoomStep) as number
        const { width, defaultWidth } = getSize(zoomAount)

        const newWidth = (width * 16) / defaultWidth


        return (
            <div style={{width: newWidth, minWidth: newWidth, backgroundColor: tradeColor}} className={classes.TradeIndicator}>

            </div>
        )
    }

    getBorderStyle = () => {
        const { zoom, isTagSelected, isSelecting } = this.props

        if(!isTagSelected && !isSelecting ) {
            return {}
        }

        const style =  {}
        
        if(zoom > 90) {
            style['outlineStyle'] = 'dashed'
        } else {
            style['outlineStyle'] = 'solid'
        }
        if(zoom > 90) {
            style['outlineWidth'] = 3
        } else if(zoom <= 90 && zoom >= 60) {
            style['outlineWidth'] = 5

        } else {
            style['outlineWidth'] = 10

        }


        return style
    }

    LargeTagCard = () => {
        const { uid, isMilestone, tagDate, status, tagCardType } = this.props
        const { zoomStep, type, classes, selectableRef, isTagSelected, isSelecting, tradeColor, column } = this.props

        const zoomAmount = getZoomAmount(this.props.zoomStep)

        const { width, height, margin, paddingTop, paddingRight, paddingLeft, defaultWidth, fontSize } = getSize(zoomAmount)

        const selectedClass = isTagSelected || isSelecting  ? classes.SelectedTag : ""

        const borderStyle = this.getBorderStyle()
        
        const tagId = uid

        if(!!isMilestone) {
            const newColor = chroma(tradeColor).brighten().hex()

            const borderDashedIsBacklog = !!tagDate ? 'solid' : 'dashed'

            const makeOpaque = !!status && status == 'DoneDone' ? classes.MakeOpaque : ""

            const isRightCrossOutBacklog = !!tagDate ? classes.CrossOutLineRightMilestone : classes.CrossOutLineRightMilestoneBacklog
            const isLeftCrossOutBacklog = !!tagDate ? classes.CrossOutLineLeftMilestone : classes.CrossOutLineLeftMilestoneBacklog 

            return (
                <div
                    ref={selectableRef}
                    key={tagId}
                    onDoubleClick={this.onTagDoubleClick}
                    onClick={this.onTagClick}
                    className={classNames(classes.MilestoneBackground, selectedClass, makeOpaque, "TagCard")} style={{
                        backgroundColor: !!newColor ? newColor: '#42A5F5',
                        width:  (width / Math.sqrt(2)), 
                        height: (width / Math.sqrt(2)), 
                        borderStyle: borderDashedIsBacklog,
                        borderColor: !!tradeColor ? tradeColor :  '#42A5F5', 
                        paddingTop: paddingTop, 
                        paddingRight: paddingRight, 
                        paddingLeft: paddingLeft,
                        transform: 'rotate(45deg)',
                        ...borderStyle
                    }}>

                    {  !!status && status == 'DoneDone' || status == 'Done' ? 
                        <div style={{borderColor: !!tradeColor ? tradeColor :  '#42A5F5'}} className={isRightCrossOutBacklog}></div> 
                        : null }
                        
                    {  !!status && status == 'DoneDone' || status == 'Done' ? 
                    <div style={{borderColor: !!tradeColor ? tradeColor :  '#42A5F5'}} className={isLeftCrossOutBacklog}></div>
                    : null }
                        
                    <div className={classes.MilestoneForeground}>
                        {this.renderContent()}
                    </div>
                </div>
            )
        }


        if(tagCardType === TagType.Constraint) {
            let bgBorderColor = tradeColor
            if(tradeColor === '#000') bgBorderColor = '#4286DD'

            const bgColor = chroma(bgBorderColor).brighten().hex()
            let borderDashedIsBacklog
            if (type === ColumnType.Lookahead)  borderDashedIsBacklog = !!tagDate ? 'solid' : 'dashed'
            if (type === ColumnType.PhasePlan)  borderDashedIsBacklog = !!column ? 'solid' : 'dashed'
            
            const makeOpaque = !!status && status == 'DoneDone' ? classes.MakeOpaque : ""

            const isRightCrossOutBacklog = !!tagDate ? classes.CrossOutLineRightConstraint : classes.CrossOutLineRightConstraintBacklog
            const isLeftCrossOutBacklog = !!tagDate ? classes.CrossOutLineLeftConstraint : classes.CrossOutLineLeftConstraintBacklog 
            
            return (
                <div 
                    ref={selectableRef}
                    key={tagId}
                    className={classNames(classes.PhasePlanTagCard,  selectedClass, makeOpaque, "TagCard")}
                    onDoubleClick={this.onTagDoubleClick}
                    onClick={this.onTagClick} 
                    style={{
                        width: width, 
                        height: width, 
                        margin: margin, 
                        backgroundColor: bgColor,
                        paddingTop: paddingTop, 
                        paddingRight: paddingRight, 
                        paddingLeft: paddingLeft,
                        borderStyle: borderDashedIsBacklog,
                        borderColor: bgBorderColor,
                        ...borderStyle
                    }} >

                        {  !!status && status == 'DoneDone' || status == 'Done' ? 
                        <div style={{borderColor: bgBorderColor}} className={isRightCrossOutBacklog}></div> 
                        : null }

                        {  !!status && status == 'DoneDone' || status == 'Done' ? 
                        <div style={{borderColor: bgBorderColor}} className={isLeftCrossOutBacklog}></div>
                        : null }

                        {this.renderContent()}
                </div>
            )
        }

        if(!isMilestone && type === ColumnType.Lookahead) {
            const newBorderRadius = (width * 4) / defaultWidth
            const newColor = chroma(tradeColor).brighten().hex()
            const shouldRotate = !!status && status == 'Done' ? classes.RotateTag : ""
            const makeOpaque = !!status && status == 'DoneDone' ? classes.MakeOpaque : ""

            return(
                <div 
                    ref={selectableRef}
                    key={tagId} 
                    style={{
                        width: width, 
                        height: height, 
                        margin: margin, 
                        borderRadius: newBorderRadius,
                        backgroundColor: newColor,
                        ...borderStyle
                    }}
                    className={classNames(classes.NewTagCard,  selectedClass, "TagCard", shouldRotate, makeOpaque)}
                    onDoubleClick={this.onTagDoubleClick}
                    onClick={this.onTagClick} 
                >
                    {this.renderTradeColor()}
                    {this.renderContent()}

                </div>
            )
        }
        
        if(!isMilestone && type === ColumnType.PhasePlan)  {
            const newBorderRadius = (width * 4) / defaultWidth
            const newColor = chroma(tradeColor).brighten().hex()
                return(
                    <div 
                        ref={selectableRef}
                        key={tagId} 
                        style={{
                            width: width, 
                            height: height, 
                            margin: margin, 
                            borderRadius: newBorderRadius,
                            backgroundColor: newColor,
                            ...borderStyle
                        }}
                        className={classNames(classes.NewTagCard,  selectedClass, "TagCard")}
                        onDoubleClick={this.onTagDoubleClick}
                        onClick={this.onTagClick} 
                    >
                        {this.renderTradeColor()}
                        {this.renderContent()}
                    </div>
                )
        }
    }



    getDraggableStyle = (style, snapshot) => {
        if (!snapshot.isDropAnimating) {
            return style;
        }
        
        return {
            ...style,
            // cannot be 0, but make it super tiny
            transitionDuration: `0.001s`,
        }
    }

    optionalPortal(styles, element) {
        if(styles.position === 'fixed') {
            if(!_dragEL) {
                _dragEL = document.getElementById('draggable');
            }
            if(!!_dragEL) {
                return createPortal(
                    element,
                    _dragEL,
                );
            }
            
        }
        return element;
    }
    

    render() {
            const { uid, name, tagCardType } = this.props
            const { isDisabled, index, isTagCommitted, isLockedDown } = this.props
            
            const tagId = uid

            const attributes = {
                'column': this.props.column !== null && this.props.column !== undefined ? this.props.column : -1,
                'row': this.props.index !== null && this.props.index !== undefined ? this.props.index : -1,
        
                'tagId': !!uid ? uid : "",
                'tagType': !!tagCardType ? tagCardType : null
            }

            const canMove = this.canAccessTag();

            return (

                    <Draggable 
                            index={index}
                            key={tagId}
                            draggableId={tagId}
                            isDragDisabled={isDisabled || isLockedDown || !canMove }
                    >
                            {(provided: DraggableProvided, snapshot:DraggableStateSnapshot) => {

                                const styledrag = this.getDraggableStyle(provided.draggableProps.style,snapshot)
                                return (
                                    <div>
                                        {this.optionalPortal(provided.draggableProps.style, (
                                            <div
                                                
                                                isDragging={snapshot.isDragging}
                                                style={{
                                                    ...this.getDraggableStyle(provided.draggableProps.style,snapshot), 
                                                    outline: 0,
                                                    position: snapshot.isDragging ? 'absolute' : '', 
                                                }}
                                                ref={provided.innerRef}
                                                {...provided.draggableProps}
                                                {...provided.dragHandleProps} 
                                            >
                                                <ContextMenuTrigger
                                                    holdToDisplay={-1}
                                                    disable={isDisabled || !canMove || isLockedDown}
                                                    name={name} 
                                                    attributes={attributes} 
                                                    id="tag_context_menu"
                                                >
                                                    <div style={{ zIndex: '-1'}}>
                                                        <Badge
                                                            invisible={!isTagCommitted}
                                                            overlap={tagCardType === TagType.Constraint ? "circle" : "rectangle"} 
                                                            anchorOrigin={{
                                                                vertical: 'top',
                                                                horizontal: 'right',
                                                            }}
                                                            badgeContent={<SmallAvatar>P</SmallAvatar>}

                                                        >
                                                            {this.LargeTagCard()}
                                                        </Badge>
                                                    </div>
                                                </ContextMenuTrigger>
                                            </div>
                                        ))}
                                    </div>
                            )
                        }}

                    </Draggable>
            )
        }

    canAccessTag = () => {
        const { tradeId, userTrades, isAdmin } = this.props

        let canMove = false;

        if (isAdmin) {
            canMove = true;
        }

        if (!!userTrades && !!tradeId && !isAdmin) {
            canMove = userTrades.has(tradeId);
        }
        return canMove;
    }
}


const makeMapStateToProps = () => {
    const isTagSelected = makeIsTagSelected();
    const getTagData = makeGetTagData();
    const mapStateToProps = (state:any, ownProps?: any) => ({
        isTagSelected: isTagSelected(state, ownProps),
        isTagCommitted: isTagCommitted(state, ownProps),
        isLockedDown: isLockedDown(state),
        ...getTagData(state, ownProps),
        zoom: getZoom(state)
    });
    return mapStateToProps;
}

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, any>) => {

    return {
        errorAlert: (message: string) => dispatch(alertActions.error(message)),
        onPhasePlanTagClicked: (event:any, tagId:string, selectedTag: SelectedTag) => dispatch(phasePlanActions.onTagClicked(event, tagId, selectedTag)),
        onPhasePlanTagDoubleClicked: (event:any, tagId:string, selectedTag: SelectedTag) => dispatch(phasePlanActions.onTagDoubleClicked(event, tagId, selectedTag)),
        onLookaheadTagClicked: (event:any, tagId:string , selectedTag: SelectedTag) => dispatch(lookaheadActions.onTagClicked(event, tagId, selectedTag)),
        onLookaheadTagDoubleClicked: (event:any, tagId:string, isMilestone?:boolean, selectedTag: SelectedTag) => dispatch(lookaheadActions.onTagDoubleClicked(event, tagId, isMilestone, selectedTag))
    }
};
export const TagCard =  compose(
  withStyles(tagCardStyle, { withTheme: true }),
  connect(makeMapStateToProps, mapDispatchToProps),
  createSelectable,
)(_TagCard);



// WEBPACK FOOTER //
// ./src/components/PhasePlan/TagCard.tsx